import { breakpoints } from '@/const/commonStyles'

export const getInitialDeviceType = () => {
  if (typeof window === 'undefined') {
    return true
  }

  return window.innerWidth >= breakpoints.desktop
}
